import { createFeatureSelector, createSelector } from '@ngrx/store';
import { PricingState } from './pricing.reducer';

export const selectPricingState = createFeatureSelector<PricingState>('pricing');

export const selectDeveloperPlanId = createSelector(
    selectPricingState,
    (state) => state.developerPlanId
);

export const selectShowPricingModal = createSelector(
    selectPricingState,
    (state) => state.showPricingModal
);

export const selectPricingInfo = createSelector(
    selectPricingState,
    (state) => ({
        developerPlanId: state.developerPlanId,
        subscription: state.subscription,
        currentUsage: state.currentUsage,
        developerPlans: state.developerPlans
    })
);

export const selectPricingLoading = createSelector(
    selectPricingState,
    (state) => state.loading
);

export const selectPricingError = createSelector(
    selectPricingState,
    (state) => state.error
); 